import { Text } from '@hhgtech/hhg-components/mantine'
import { Flex, Switch, SwitchProps, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

type Props = {
  label?: string
  withAsterisk?: boolean
} & SwitchProps

const CheckYourSelfSwitching = ({ label, ...props }: Props) => {
  const { formatMessage: f } = useIntl()

  return (
    <Flex
      gap={rem(4)}
      sx={{
        padding: '8px 0',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Text size="s4" color="gray.6">
        {label ||
          f({
            id: 'tools.checkYrs',
            defaultMessage: 'Are you checking for yourself?',
          })}
      </Text>
      <Switch
        labelPosition="left"
        onLabel={f({ id: 'switchBtn.yes' })}
        offLabel={f({ id: 'switchBtn.no' })}
        {...props}
        styles={(theme) => ({
          trackLabel: {
            fontSize: rem(12),
          },
          track: {
            cursor: 'pointer',
          },
          body: {
            [theme.fn.largerThan('sm')]: {
              flexDirection: 'column',
              alignItems: 'flex-start',
            },
            [theme.fn.smallerThan('sm')]: {
              justifyContent: 'space-between',
            },
          },
          labelWrapper: {
            [theme.fn.smallerThan('sm')]: {
              display: 'flex',
              justifyContent: 'center',
            },
          },
        })}
      />
    </Flex>
  )
}

export { CheckYourSelfSwitching }
